// -*- Mode: rjsx -*-
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import PersonIcon from '@mui/icons-material/Person';



class ActiveProjectsList extends React.Component {
    render() {
	    let user = this.props.user;
	    if(!user.permissions.length)
	        return <em>No active projects</em>;
	    
	    return (
	        <div>
	          <strong>Active Projects</strong>
	          <ul>
		        { user.permissions.map(o => (
		            <li key={o}>
		              { o }
		            </li>))
		        }
	          </ul>
		    </div>);
		
    }
}

export class AvatarInline extends React.Component {

    constructor(props) {
	    super(props);
	    this.click = this.click.bind(this);
	    this.state = { active: false };
    }

    click() {
	    let title = this.props.user.permissions.filter(e => e.indexOf('odo-') !== -1).join(", ");
	    this.setState( {active: !this.state.active } );
    }
    
    render () {
	    let style = {
	        avatar: {
		        width: 13,
		        boxShadow: "0 0 0 1px white, 0 0 0 2px #E2E2E2",
		        marginLeft: 10,
		        marginRight: 5,
		        top: 2
	        },
	        container: {
		        display: "inline",
		        cursor: "default"
	        },
	        extras: {
		        paddingTop: 5,
		        textAlign: "right"
	        }
	    };
	    
	    let user = this.props.user;
	    let extras = null;
	    
	    if(this.state.active) {
	        style.container.display = 'fixed';
	        
	        extras = (
		        <div style={style.extras}>
		          <strong><a href={"/admin/user/" + user.key}>View Profile</a></strong> <br />
		          <ActiveProjectsList user={user} />
		        </div>
	        );
	    }
	    
	    return (
	        <div style={style.container} onClick={this.click}>
	          <img style={style.avatar} src={user.avatar_url} /> {user.name}
	          { extras }
	        </div>);
    }
}


export class AvatarSig extends React.Component {

    render() {
	    let style = {
	        sig: {
		        textAlign: "right"
	        }
	    };	
	    return (
    	    <div style={style.sig}>
	          <AvatarInline user={this.props.user} />
	        </div>
	    );
    }
}

export function AvatarImage(props)  {
    
	return (props.user && props.user.key) ?
        <img style={props.style} src={props.user.avatar_url} /> :
    <PersonIcon style={props.style}  />;
    
}

